import React, { useEffect, useRef, useState } from 'react'

export default function YoutubeVideo({
  embedUrl = '',
  title = 'YouTube video player',
  height = 256,
}) {
  const [iframeHeight, setIframeHeight] = useState(height)
  const iframeRef = useRef(null)

  useEffect(() => {
    const onResize = () => {
      const iframeWidth = iframeRef?.current?.clientWidth
      if (iframeWidth && iframeWidth > 300) {
        setIframeHeight(Math.ceil((iframeWidth * 9) / 16))
      }
    }

    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  return (
    <iframe
      ref={iframeRef}
      src={embedUrl}
      title={title}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media;"
      allowFullScreen
      style={{ height: iframeHeight, width: '100%' }}
    />
  )
}
